jQuery(($) => {
	const $chatContainer = $('.sc-docsbot');

	if (!$chatContainer.length) {
		return;
	}

	insertMarkdownScript();

	insertDompurifyScript();

	const $answerContainerContainer = $('.sc-docsbot-answer-c');
	const $answerContainer = $('.sc-docsbot-answer');

	const $inputForm = $('.sc-docsbot-input-container');
	const $submitButton = $('.sc-docsbot-input__submit');
	const $questionInput = $('.sc-docsbot-input__input');

	const answerContainerOpenClass = 'sc-docsbot-answer-c--open';

	let chatHistory = [];

	let inputIsLocked = false;

	let ws;
	let answerP;
	let loaderEl, loaderInterval;

	let currentQuestion, currentAnswer;

	function isWebsocketClosed() {
		return ws?.readyState === WebSocket.CLOSED;
	}

	function isWebsocketOpen() {
		return ws?.readyState === WebSocket.OPEN;
	}

	function scrollAnswerContainerToBottom() {
		$answerContainer.scrollTop($answerContainer[0].scrollHeight); // Scroll to the bottom of the container
	}

	function startNewAnswer() {
		answerP = $('<p></p>');

		$(`<p style="margin-bottom:0"><strong>Question:</strong> ${currentQuestion}</p>`).appendTo($answerContainer);
		$('<p style="margin-bottom:0"><strong>Answer:</strong></p>').appendTo($answerContainer);

		addLoader();

		answerP.appendTo($answerContainer);

		currentAnswer = '';

		scrollAnswerContainerToBottom();
	}

	function processStreamWord(word) {
		return word.replace(/\n/g, "<br>");
	}

	function addWordToAnswer(word) {
		answerP.append(word);

		scrollAnswerContainerToBottom();
	}

	function addLoader() {
		loaderEl = $('<p></p>');
		loaderEl.appendTo($answerContainer);

		let dots = ''; // Initialize an empty string to store the dots

		loaderInterval = setInterval(function () {
			dots += '.'; // Add a dot to the string
			if (dots.length > 3) {
				dots = '.'; // Reset the dots string after reaching 3 dots
			}
			loaderEl.text(dots); // Update the text content of the <p> tag with the dots
		}, 500); // Set the interval to 500 milliseconds (0.5 seconds)
	}

	function removeLoader() {
		loaderEl.remove();

		clearInterval(loaderInterval);
	}

	function lockInput() {
		$submitButton.prop('disabled', true);

		inputIsLocked = true;
	}

	function unlockInput() {
		$submitButton.prop('disabled', false);

		inputIsLocked = false;
	}

	function processFinalAnswer() {
		const replacedAnswer = processAnswer(currentAnswer);

		$(replacedAnswer).insertAfter(answerP);

		answerP.remove();

		// answerP.html(replacedAnswer);
	}

	function processAnswer(answer) {
		if (window.marked && window.DOMPurify) {
			const renderer = new marked.Renderer();

			renderer.link = function (href, title, text) {
				return `<a href="${href}" target="_blank">${text}</a>`;
			};

			const html = marked(answer, {renderer});

			const sanitizedHtml = DOMPurify.sanitize(html, {
				ADD_ATTR: ['target']
			});

			return sanitizedHtml;
		}

		// const currentHost = 'sheercustom.com';

		const expressionWithHttp =
			/(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*))/gi;

		const regex = new RegExp(expressionWithHttp);

		// return answer.replace(regex, "<a href='$1'>$1</a>");

		return answer.replace(regex, function (matched, group1) {
			// don't open any links in the same tab as it will remove the chat history
			// if (group1.includes(currentHost)) {
			// 	return `<a href='${group1}'>${group1}</a>`;
			// } else {
			return `<a href='${group1}' target='_blank'>${group1}</a>`;
			// }
		});
	}

	function initChatBot() {
		const teamId = 'HR3iRxyT5SOaaCqG9aEh';
		const botId = 'dGpboMbkxPjseeYsBJN5';

		const apiUrl = `wss://api.docsbot.ai/teams/${teamId}/bots/${botId}/chat`;

		ws = new WebSocket(apiUrl);

		ws.onopen = function (event) {
			// WebSocket connection is established, do any necessary setup here
		};

		ws.onclose = () => {
		}

		ws.onmessage = function (event) {
			const data = JSON.parse(event.data)

			if (data.sender === 'bot') {
				if (data.type === 'start') {
					//start a new answer, streaming will follow
					//start response looks like this JSON:
					/*
					  {
						  sender="bot",
						  message="",
						  type="start"
					  }
					  */
				} else if (data.type === 'stream') {
					removeLoader();

					const str = processStreamWord(data.message);

					addWordToAnswer(str);

					currentAnswer += data.message;

					//this is a streaming response word by word, it will be sent many times. Update the UI by appending these messages to the current answer.
					//stream response looks like this JSON:
					/*
					  {
						  sender="bot",
						  message="Word1",
						  type="stream"
					  }
					  */
				} else if (data.type === 'info') {
					//info response not generally used, looks like this JSON:
					/*
					  {
						  sender="bot",
						  message="Synthesizing question...",
						  type="info"
					  }
					  */
				} else if (data.type === 'end') {
					unlockInput();

					processFinalAnswer();

					//this is the final response containing all data, it will be sent once after streaming completes. Update the UI with the final answer and sources.

					//parse the message property which is a JSON string
					const endData = JSON.parse(data.message)

					chatHistory = endData.history; //this is the new chat history array to pass back with the next question

					ws.close()
				} else if (data.type === 'error') {
					unlockInput();

					alert(data.message);

					ws.close()
				}
			}
		}

		ws.onerror = function (event) {
			if (inputIsLocked) {
				console.warn(event);
				alert('There was a connection error. Please try again.');

				unlockInput();

				removeLoader();
			}
		};
	}

	function insertMarkdownScript() {
		const script = document.createElement("script");

		script.src = "https://cdn.jsdelivr.net/npm/marked@3.0.7/marked.min.js";

		document.head.appendChild(script);
	}

	function insertDompurifyScript() {
		const script = document.createElement("script");

		script.src = "https://cdnjs.cloudflare.com/ajax/libs/dompurify/3.0.5/purify.min.js";

		document.head.appendChild(script);
	}

	$($inputForm).on('submit', (e) => {
		e.preventDefault();

		currentQuestion = $questionInput.val();

		if (currentQuestion !== '') {
			$answerContainerContainer.addClass(answerContainerOpenClass);

			startNewAnswer();

			const req = {question: currentQuestion, full_source: false, history: chatHistory};

			lockInput();

			$questionInput.val('');

			if (!ws || isWebsocketClosed()) {
				initChatBot();

				ws.onopen = function () {
					ws.send(JSON.stringify(req)); // Send the message after the WebSocket connection is established
				};
			} else if (isWebsocketOpen()) {
				ws.send(JSON.stringify(req)); // Send the message if the WebSocket is already open
			}
		}
	});
});